import React, { useState } from 'react';
import classNames from "classnames";

import { TrueFalseProps } from "./TrueFalse.type";

import AudioButton from "../common/AudioButton/AudioButton";
import { ImageCard } from "../common/ImageCard/ImageCard";
import { Controls } from "../../Controls";
import ConfirmButton from "../common/ConfirmButton/ConfirmButton";
import { TrueFalseOption } from "../common/TrueFalseOption/TrueFalseOption";

import './styles.scss';

export const TrueFalse: React.FC<TrueFalseProps> = ({
  images,
  audio,
  answer,
  controls,
}) => {
  const [optionIsSelected, setOptionIsSelected] = useState<boolean>(false);
  const [selectedOption, setSelectedOption] = useState<string>("");
  const [selectedIsCorrect, setSelectedIsCorrect] = useState<boolean>(false);
  const [checkIsDone, setCheckIsDone] = useState<boolean>(false);
  const { handlePrev, handleNext, lastItemIndex, currentIndex } = controls;

  const handleOptionClick = ({ option }: { option: string }) => {
    setSelectedOption(option);
    // setSelectedIsCorrect(option === answer);
    setOptionIsSelected(true);
    setSelectedIsCorrect(option === answer);
  }

  const handleNextClick = () => {
    setCheckIsDone(false);
    handleNext();
  }

  const onConfirmClick = () => {
    setCheckIsDone(true);
  }

  const resetSelection = () => {
    setOptionIsSelected(false);
    setSelectedIsCorrect(false);
    setCheckIsDone(false);
    setSelectedOption("");
  };

  return (
    <>
      <div
        className={classNames("ActivityContainer TrueFalse", {
          "CheckIsDone": checkIsDone,
        })}>
        <div className="ImagesContainer">
          {!!images?.length && images.map(image => <ImageCard path={image.path}/>)}
        </div>
        <div className="AudioContainer">
          {!!audio.length && audio.map(item => <AudioButton src={item.path} currentIndex={currentIndex}/> )}
        </div>
        <div className="AnswerOptions">
          <TrueFalseOption
            option="true"
            isOptionSelected={selectedOption === "true"}
            checkIsDone={checkIsDone}
            handleOptionClick={() => handleOptionClick({ option: "true" })}
            selectedIsCorrect={selectedIsCorrect}
          />
          {/*<div*/}
          {/*  className={classNames("AnswerOption TrueOption", {*/}
          {/*  "isSelected": selectedOption === "true",*/}
          {/*  "isCorrect": optionIsSelected && checkIsDone && selectedIsCorrect,*/}
          {/*  "isIncorrect": checkIsDone && !(optionIsSelected && selectedIsCorrect),*/}
          {/*})}*/}
          {/*  onClick={() => handleOptionClick({ option: "true" })}*/}
          {/*>*/}
          {/*  <ThumbsUp className="Icon ThumbsUp" />*/}
          {/*</div>*/}

          <TrueFalseOption
            option="false"
            isOptionSelected={selectedOption === "false"}
            checkIsDone={checkIsDone}
            handleOptionClick={() => handleOptionClick({ option: "false" })}
            selectedIsCorrect={selectedIsCorrect}
          />
          {/*<div*/}
          {/*  className={classNames("AnswerOption FalseOption", {*/}
          {/*    "isSelected": selectedOption === "false",*/}
          {/*    "isCorrect": optionIsSelected && checkIsDone && selectedIsCorrect,*/}
          {/*    "isIncorrect": checkIsDone && !(optionIsSelected && selectedIsCorrect),*/}
          {/*  })}*/}
          {/*  onClick={() => handleOptionClick({ option: "false" })*/}
          {/*}>*/}
          {/*  <ThumbsUp className="Icon ThumbsDown" />*/}
          {/*</div>*/}
        </div>
        <div className="ConfirmButtonContainer">
          <ConfirmButton
            onConfirm={onConfirmClick}
            optionIsSelected={optionIsSelected}
            selectedIsCorrect={selectedIsCorrect}
            setCheckIsDone={setCheckIsDone}
            resetSelection={resetSelection}
            showCorrectStatus={checkIsDone}
            checkIsDone={checkIsDone}
          />
        </div>
      </div>
      <Controls handlePrev={handlePrev} handleNext={handleNextClick} currentIndex={currentIndex} lastItemIndex={lastItemIndex}/>
    </>
  );
};
